import React, { useState, useEffect } from 'react';
import { AlertCircle, X, AlertTriangle } from 'lucide-react';

const AlertWidget = ({ validationResult, onClose }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (validationResult && (validationResult.errors?.length > 0 || validationResult.warnings?.length > 0)) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    }, [validationResult]);

    if (!isVisible || !validationResult) return null;

    const hasErrors = validationResult.errors?.length > 0;
    const hasWarnings = validationResult.warnings?.length > 0;

    return (
        <div style={{
            position: 'fixed',
            top: '80px',
            right: '20px',
            width: '400px',
            backgroundColor: 'var(--bg-card)',
            border: `1px solid ${hasErrors ? 'var(--error-color)' : 'var(--warning-color)'}`,
            borderRadius: '12px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.5)',
            zIndex: 9999,
            overflow: 'hidden',
            animation: 'slideInRight 0.3s ease-out'
        }}>
            {/* Header */}
            <div style={{
                padding: '12px 16px',
                backgroundColor: hasErrors ? 'rgba(239, 68, 68, 0.1)' : 'rgba(245, 158, 11, 0.1)',
                borderBottom: `1px solid ${hasErrors ? 'rgba(239, 68, 68, 0.2)' : 'rgba(245, 158, 11, 0.2)'}`,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {hasErrors ? (
                        <AlertCircle size={20} color="var(--error-color)" />
                    ) : (
                        <AlertTriangle size={20} color="var(--warning-color)" />
                    )}
                    <span style={{ fontWeight: 600, color: hasErrors ? 'var(--error-color)' : 'var(--warning-color)' }}>
                        {hasErrors ? 'Connection Failed' : 'Configuration Setup Required'}
                    </span>
                </div>
                <button
                    onClick={() => { setIsVisible(false); if (onClose) onClose(); }}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-secondary)' }}
                >
                    <X size={18} />
                </button>
            </div>

            {/* Content */}
            <div style={{ padding: '16px', maxHeight: '400px', overflowY: 'auto' }}>
                {hasErrors && (
                    <div style={{ marginBottom: hasWarnings ? '16px' : '0' }}>
                        <h4 style={{ margin: '0 0 8px 0', fontSize: '0.9rem', color: 'var(--text-primary)' }}>Errors</h4>
                        <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
                            {validationResult.errors.map((err, idx) => (
                                <li key={idx} style={{ marginBottom: '4px' }}>{err}</li>
                            ))}
                        </ul>
                    </div>
                )}

                {hasWarnings && (
                    <div>
                        <h4 style={{ margin: '0 0 8px 0', fontSize: '0.9rem', color: 'var(--text-primary)' }}>Warnings (Action Required)</h4>
                        <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
                            {validationResult.warnings.map((warn, idx) => (
                                <li key={idx} style={{ marginBottom: '8px', lineHeight: '1.4' }}>
                                    {warn.includes('AWS RDS') ? (
                                        <span>
                                            <strong>AWS RDS Config Missing:</strong> {warn}
                                            <div style={{ marginTop: '4px', fontSize: '0.8rem', opacity: 0.8 }}>
                                                Set <code>rds.logical_replication = 1</code> in Parameter Groups and <strong>Reboot</strong>.
                                            </div>
                                        </span>
                                    ) : warn}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
            <style>{`
                @keyframes slideInRight {
                    from { transform: translateX(100%); opacity: 0; }
                    to { transform: translateX(0); opacity: 1; }
                }
            `}</style>
        </div>
    );
};

export default AlertWidget;
